import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { Addendum } from "types";

type CreateAddendumPayload = {
  text: string;
};

function useCreateAddendum(encounterId: string) {
  return useAxiosMutation(
    ["createAddendum", { encounterId }],
    (input: CreateAddendumPayload) =>
      axiosChartInstance.post<Addendum>(`v1/addendum/${encounterId}`, input)
  );
}

export type { CreateAddendumPayload };
export { useCreateAddendum };
